import React, { useState } from 'react'
import { Dropdown, Menu } from 'antd'
import { Link } from 'react-router-dom'
import pluralize from 'pluralize'

import { AiOutlineDown } from 'react-icons/ai'

import { stringifyDate } from '../../modules'

import Receive from '../reusable/receive'

const Consumables = ({ loading, storeName, requests, error, patient, page, limit, Paginate, path }) => (
    <Receive
        progress
        loading={loading}
        error={error}>
        {
            requests?.length > 0 ?
                <>
                    <div className="overflow-x-auto">
                        <table className="table-auto w-full">
                            {/* Table header */}
                            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                <tr>
                                    <th className="p-2">
                                        <div className="font-semibold text-center">No</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Requested By</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Destination</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Status</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-center">Date</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-center"></div>
                                    </th>
                                </tr>
                            </thead>
                            {/* Table body */}
                            <tbody className="text-sm font-medium divide-y divide-gray-100">
                                {
                                    requests.map((request, key) => 
                                        <tr>
                                            <td className="p-2">
                                                <div className="text-center">
                                                    { ((page - 1) * limit) + (key + 1) }.
                                                </div>
                                            </td>
                                            <td className="p-2">
                                                <div className="text-left">{ request.requestedBy?.name }</div>
                                                <p className="text-gray-500 text-xs italic">{ request?.requests?.length } { pluralize('items', request.requests.length) }</p>
                                            </td>
                                            <td className="p-2">
                                                <div className="text-left">{ request.destination?.name }</div>
                                            </td>
                                            <td className="p-2">
                                                <p className={ `text-${ request.cancelled ? 'gray' : request.seen ? 'green' : 'yellow'}-500 my-0` }>{ request.gray ? 'Cancelled' : request.seen ? 'Seen' : 'Pending' }</p>
                                            </td>
                                            <td className="p-2">
                                                <div className="text-center">{stringifyDate(request.date)}</div>
                                            </td>
                                            <td className="p-2 text-center">
                                                <Dropdown
                                                    overlay={
                                                        <Menu>
                                                            <Link to={ `${path}/consumables/${request._id}` }><Menu.Item>View</Menu.Item></Link>
                                                        </Menu>
                                                    }>
                                                    <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                    {Paginate}
                </>
            :
                <div className="w-full h-16 flex items-center justify-center">
                    <p className="font-semibold text-base">No consumables were ordered for { patient }</p>
                </div>
        }
    </Receive>
)

export default Consumables